import type { NavigationScreen } from 'app/types/navigation';
import { Platform, View } from 'react-native';
import { InterestsScreenBody } from './interests-screen-body';
import { useInterestsScreen } from './use-interests-screen';
import { useModalCardLayout } from './use-modal-card-layout';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const InterestsScreenLarge: NavigationScreen<'interests'> = ({ navigation, route }) => {
  const { itemWidth, onCardLayout } = useModalCardLayout();
  const screenState = useInterestsScreen({
    navigation,
    route,
    itemWidth,
    webAggregateListingSteps: Platform.OS === 'web',
    webListingLayout: Platform.OS === 'web' ? 'large' : undefined,
  });

  if (screenState.carouselItems.length === 0) {
    navigation.goBack();
    return null;
  }

  return (
    <View onLayout={onCardLayout} style={{ flex: 1, backgroundColor: theme.colors['surface.tertiary'] }}>
      <InterestsScreenBody {...screenState} />
    </View>
  );
};
